export const MODULE_NAME = 'integrators'; //BaseApi
export const VENDOR = 'integrator';
export const VENDORS = 'integrators';
export const RELOAD_VENDORS = 'reloadVendors';
export const SAVE_VENDOR = 'saveVendor';
export const SET_VENDOR = 'setVendor';
export const SET_VENDOR_BY_CODE = 'setVendorByCode';
export const SET_VENDORS = 'setVendors';
export const SHOW_VENDOR_MODAL = 'showVendorModal';
export const SHOW_DEPENDENT_VENDOR_MODAL = 'showDependentVendorModal';
export const SHOW_INTEGRATIONS_MODAL = 'showIntegrationsModal';
export const DEACTIVATE_VENDOR = 'deactivateVendor';
export const SAVE_VUENIVERSITY = 'saveVueniversityLink';
export const SET_VUENIVERSITY = 'setVueniversityLink';
export const VUENIVERSITY = 'vueniversityLink';
//--- contacts
export const SAVE_CONTACT_VENDOR = 'saveContactVendor';
export const SET_CONTACT_VENDOR = 'setContactVendor';
export const SET_CONTACTS_VENDOR = 'setContactsVendor';
export const CONTACTS_VENDOR = 'contactsVendor';
export const CONTACT = 'contactVendor';
export const DELETE_CONTACT_VENDOR = 'deleteContactVendor';
export const SET_DEPENDENTS_VENDOR = 'setDependentsVendor';
export const DEPENDENTS_VENDOR = 'dependentsVendor';
export const LOADED_DEPENDENTS = 'loadedDependents';
export const SET_LOADED_DEPENDENTS = 'setLoadedDependents';
// --- DealershipCompaniesController

export const SET_DEALERSHIPCOMPANIES = 'setDealershipCompanies';
export const DEALERSHIPCOMPANIES = 'dealershipCompanies';
export const SHOW_DEALERSHIPCOMPANIES_MODAL = 'showDealershipCompaniesModal';
export const TOTAL_CUSTOMERS_COUNT = 'totalCustomersCount';
// --- matches vendors
export const MATCHES = 'integratorMatches';
export const SET_MATCHES = 'setIntegratorMatches';

import {
	ERROR as error,
	SET_ERROR as setError
} from '@/sections/error-mutation-types';

export const ERROR = error;
export const SET_ERROR = setError;

import {
	LOADING as loading,
	SET_LOADING as setLoading
} from '@/sections/loading-mutation-types';

export const LOADING = loading;
export const SET_LOADING = setLoading;

export const TOAST_MESSAGES_PUSH = 'toastMessages/push';
